import { z } from 'zod';
import { MediaPlan } from 'shared/src/domain/media-buy/media-buy-types';
import { ListMetaApi } from 'shared/src/api/common-api-types';

export const MediaPlanApiResponse = MediaPlan.meta({
  description:
    'Media plan with platform buy details including budget, costs, and media buy metadata'
}).meta({
  id: 'MediaPlanApiResponse',
  description: 'Media plan with platform buy details'
});

export type MediaPlanApiResponse = z.infer<typeof MediaPlanApiResponse>;

export const MediaPlanApiCreateRequest = z
  .object({
    media_buy_id: z.uuid().meta({
      description: 'Platform buy reference'
    }),
    name: z.string().nullable().meta({
      description: 'Media plan name'
    })
  })
  .meta({
    id: 'MediaPlanApiCreateRequest',
    description: 'Media plan input for create'
  });

export type MediaPlanApiCreateRequest = z.infer<typeof MediaPlanApiCreateRequest>;

export const MediaPlanApiUpdateRequest = z
  .object({
    name: z.string().nullable().optional().meta({
      description: 'Media plan name'
    })
  })
  .meta({
    id: 'MediaPlanApiUpdateRequest',
    description: 'Media plan input for update'
  });
export type MediaPlanApiUpdateRequest = z.infer<typeof MediaPlanApiUpdateRequest>;

export const MediaPlanApiListResponse = z
  .object({
    data: z.array(MediaPlanApiResponse),
    meta: ListMetaApi
  })
  .meta({
    id: 'MediaPlanApiListResponse',
    description: 'Paginated list of media plans'
  });

export type MediaPlanApiListResponse = z.infer<typeof MediaPlanApiListResponse>;
